document.addEventListener('DOMContentLoaded', function () {
  // Observer pour détecter quand le carousel est chargé
  const observer = new MutationObserver((mutations, obs) => {
    const carousel = document.querySelector('#judgeme_product_reviews');
    // check if carousel is loaded with jdgm--done-setup-widget
    if (carousel && carousel.classList.contains('jdgm--done-setup-widget')) {
      obs.disconnect(); // On arrête d'observer une fois qu'on a trouvé le carousel
      updateAverageValue(carousel);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function updateAverageValue(carousel) {
    const averageValue = carousel.querySelector('[data-average-rating]').getAttribute('data-average-rating');
    const average = carousel.querySelector('.jdgm-rev-widg__summary-average');
    const averageValueFormatted = Math.round(averageValue * 10) / 10;
    var averageValueFormattedString = averageValueFormatted.toString();
    averageValueFormattedString = averageValueFormattedString
    .replace('.', ',')
    .replace(',0', '');

    if (average) {
      average.innerHTML = averageValueFormattedString + ' / 5';
      average.style.opacity = '1';
    }
    carousel.classList.add('active');
  }

});